import { type UserList, getUserName } from 'models';
import { Col, InfinityLoading, Row, Skeleton, Space, Text } from 'ui';
import { useUser } from 'features/auth';
import { IconDirectMessageButton } from 'features/chat';
import { AvatarLink } from '../avatar-link';
import { UserNameLink } from '../user-name-link';
import { UserPopover } from '../user-popover';

type P = {
  queryData: {
    fetchNextPage: () => void;
    hasNextPage?: boolean;
    isFetching: boolean;
    isLoading: boolean;
  };
  users?: UserList[];
};

const UsersList = ({ queryData: { fetchNextPage, hasNextPage, isFetching, isLoading }, users }: P) => {
  const { railsUserData: viewer } = useUser();

  return (
    <>
      {isLoading || !users ? (
        <Skeleton active paragraph={{ rows: 14 }} title={false} />
      ) : (
        <Space block orientation="vertical" size="middle">
          {users.map((user) => (
            <Row align="middle" gutter={['ms', 'xs']} justify="space-between" key={user.id}>
              <Col>
                <UserPopover user={user}>
                  <AvatarLink avatar={{ photo: user.profilePhoto, size: 32 }} userId={user.id}>
                    {getUserName(user)}
                  </AvatarLink>
                </UserPopover>
              </Col>
              <Col flex="1 1 0">
                <Row gutter="xxs">
                  <Col>
                    <UserPopover user={user}>
                      <UserNameLink type="text" userId={user.id}>
                        {getUserName(user)}
                      </UserNameLink>
                    </UserPopover>
                  </Col>
                  {user.id === viewer.id ? (
                    <Col>
                      <Text type="title" weight="medium">
                        (You)
                      </Text>
                    </Col>
                  ) : null}
                </Row>
              </Col>
              <Col>
                <IconDirectMessageButton legacyUserId={user.id} />
              </Col>
            </Row>
          ))}

          <InfinityLoading
            hasMoreData={hasNextPage}
            isLoading={isFetching}
            onEnter={fetchNextPage}
            spinnerSize="small"
          />
        </Space>
      )}
    </>
  );
};

export default UsersList;
